<template>
    <ThemeIcon class="cursor-pointer select-none" @click="changeTheme"/>
</template>

<script>
import ThemeIcon from '@/components/icons/ThemeIcon'
import { changeTheme } from '@/helper/app-helper'

export default {
    name: 'ThemeToggle',
    components: { ThemeIcon },
    methods: {
        changeTheme() {
            changeTheme()
        },
    },
}
</script>
